<template>
  <div class="luout">
    <h2 style="color: white;">🎤 语音录制</h2>
    <div v-if="!isRecording && !audioUrl">
      <button @click="startRecording">🟢 开始录音</button>
    </div>
    <div v-else-if="isRecording">
      <p>🔴 录音中...</p>
      <button @click="stopRecording">⏹️ 停止</button>
    </div>
    <div v-else-if="audioUrl">
      <p>✅ 录音完成（请播放测试）：</p>
      <audio :src="audioUrl" controls></audio>
      <br><br>
      <button class="mr10" @click="uploadAudio" :disabled="uploading">📤 确认</button>
      <button @click="reset">🔄 重录</button>
    </div>
    <div class="status" v-if="uploadResult" :style="{color: uploadResult.success ? 'green' : 'red'}">
      {{ uploadResult.message }}
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'statistics',
  data() {
    return {
      isRecording: false,
      audioContext: null,
      mediaStream: null,
      scriptProcessor: null,
      recordedBuffers: [],
      audioBlob: null,
      audioUrl: null,
      uploadResult: null
    }
  },
  props: {
    pushnum: [String, Object, Array, Number],
  },
  watch: {
    pushnum(newVal) {
      console.log('收到淡出',)
      this.isRecording = false;
      this.audioContext = null;
      this.mediaStream = null;
      this.scriptProcessor = null;
      this.audioBlob = null;
      if (this.audioUrl) URL.revokeObjectURL(this.audioUrl);
      this.audioUrl = null;
      this.audioBlob = null;
      this.uploadResult = null;
      this.uploadResult = null;
      this.recordedBuffers = [];
      this.reset();
    },
  },
  mounted() {
    console.log('pushnum',this.pushnum)
      this.isRecording = false;
      this.audioContext = null;
      this.mediaStream = null;
      this.scriptProcessor = null;
      this.audioBlob = null;
    if (this.audioUrl) URL.revokeObjectURL(this.audioUrl);
    this.audioUrl = null;
    this.audioBlob = null;
    this.uploadResult = null;
      this.uploadResult = null;
      this.recordedBuffers = [];
  },
  methods: {
    async startRecording() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        this.mediaStream = stream;

        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        this.audioContext = new AudioCtx();
        const source = this.audioContext.createMediaStreamSource(stream);

        // 使用实际采样率（更准确）
        const SAMPLE_RATE = this.audioContext.sampleRate <= 48000 ? this.audioContext.sampleRate : 48000;
        const BUFFER_SIZE = 4096;

        this.scriptProcessor = this.audioContext.createScriptProcessor(BUFFER_SIZE, 1, 1);
        this.recordedBuffers = [];

        this.scriptProcessor.onaudioprocess = (e) => {
          const input = e.inputBuffer.getChannelData(0); // Float32Array [-1, 1]
          const int16 = new Int16Array(input.length);
          for (let i = 0; i < input.length; i++) {
            // 防止溢出
            const s = Math.max(-1, Math.min(1, input[i]));
            int16[i] = s < 0 ? s * 32768 : s * 32767;
          }
          this.recordedBuffers.push(int16);
        };

        source.connect(this.scriptProcessor);
        this.scriptProcessor.connect(this.audioContext.destination);
        this.isRecording = true;
      } catch (err) {
        alert('麦克风错误：' + err);
      }
    },

    stopRecording() {
      if (!this.isRecording) return;

      this.scriptProcessor.disconnect();
      this.mediaStream.getTracks().forEach(t => t.stop());
      this.audioContext.close();

      // 合并所有 Int16Array
      let totalLen = 0;
      this.recordedBuffers.forEach(buf => totalLen += buf.length);
      const fullBuffer = new Int16Array(totalLen);
      let offset = 0;
      this.recordedBuffers.forEach(buf => {
        fullBuffer.set(buf, offset);
        offset += buf.length;
      });

      // 生成 WAV（使用实际采样率）
      const actualSampleRate = this.audioContext.sampleRate <= 48000 ? this.audioContext.sampleRate : 48000;
      this.audioBlob = this.createWavBlob(fullBuffer, actualSampleRate);
      this.audioUrl = URL.createObjectURL(this.audioBlob);
      this.isRecording = false;
    },

    async uploadAudio() {
      const fd = new FormData();
      // 第一个参数 'file'：字段名称，服务器通过这个名称获取文件
      // 第二个参数 this.audioBlob：实际的文件数据，可以是Blob、File对象或字符串
      // 第三个参数 'recording.wav'：可选的文件名，指定服务器保存时的名称
          fd.append('file', this.audioBlob, 'recording.wav');
      // axios.post('https://www.esks.com.cn/api/stt/recognize-speech', fd,{
      //   headers: {
      //     'Content-Type': 'audio/wav'
      //   }
      // }).then(res => {
      //     console.log('结果res', res);
      // }).catch(err => {
      //   console.log('结果err', err);
      // })
      try {
        // 替换为你的接口
       let res = await axios.post('https://www.esks.com.cn/api/stt/recognize-speech', fd);
        console.log('结果res', res);
        this.$nextTick(function () {
          this.$emit('gettext', res);
        })
        this.uploadResult = { success: true, message: '✅ 上传成功' };
      } catch (e) {
        this.uploadResult = { success: false, message: '❌ 上传失败'+e };
      }
    },

    reset() {
      if (this.audioUrl) URL.revokeObjectURL(this.audioUrl);
      this.audioUrl = null;
      this.audioBlob = null;
      this.uploadResult = null;
    },
// ✅ 正确的 WAV 生成函数
    createWavBlob(pcmInt16Array, sampleRate = 16000) {
      const channels = 1;
      const bitDepth = 16;
      const bytesPerSample = bitDepth / 8;
      const blockAlign = channels * bytesPerSample;
      const byteRate = sampleRate * blockAlign;

      const dataLength = pcmInt16Array.length * bytesPerSample;
      const wavHeaderSize = 44;
      const totalLength = wavHeaderSize + dataLength;

      const buffer = new ArrayBuffer(totalLength);
      const view = new DataView(buffer);

      // RIFF
      this.writeString(view, 0, 'RIFF');
      view.setUint32(4, totalLength - 8, true);
      this.writeString(view, 8, 'WAVE');

      // fmt
      this.writeString(view, 12, 'fmt ');
      view.setUint32(16, 16, true);
      view.setUint16(20, 1, true);
      view.setUint16(22, channels, true);
      view.setUint32(24, sampleRate, true);
      view.setUint32(28, byteRate, true);
      view.setUint16(32, blockAlign, true);
      view.setUint16(34, bitDepth, true);

      // data
      this.writeString(view, 36, 'data');
      view.setUint32(40, dataLength, true);

      // PCM
      let offset = wavHeaderSize;
      for (let i = 0; i < pcmInt16Array.length; i++) {
        view.setInt16(offset, pcmInt16Array[i], true);
        offset += 2;
      }

      return new Blob([buffer], {type: 'audio/wav'});
    },

    writeString(view, offset, str) {
      for (let i = 0; i < str.length; i++) {
        view.setUint8(offset + i, str.charCodeAt(i));
      }
    }
  },
  beforeDestroy() {
    if (this.audioUrl) URL.revokeObjectURL(this.audioUrl);
  }
}
</script>

<style scoped lang="scss">
.luout{
  width: 100%;
  height: 100%;
}
</style>
